import React, {useState, useEffect} from 'react';
import * as jobsActions from '../../Redux/Actions/jobs';
import { getToken, onMessageListener } from '../../utils/pushNotification';
import * as notificationActions from '../../Redux/Actions/notification';
import { toastMessage } from '../../utils/toast';
import Modal from '../Ui/Modal';

const JobRequest = ({ t, userID }) => {
    const [fcmToken, setFcmToken] = useState('');
    const [jobTitle, setJobTitle] = useState('');
    const [jobID, setJobID] = useState('');
    const [jobData, setJobData] = useState('');
    const [jobNotifyModal, setJobNotifyModal] = useState(false);

    useEffect(() => {getToken(setFcmToken);}, []);

    useEffect(() => {
        let payload = {
            id: userID, fcmToken
        };
        let oldToken = localStorage.getItem('fcmToken');
        (oldToken !== fcmToken) && (fcmToken !== '') && notificationActions.updateToken(payload).then(res => {
            localStorage.setItem('fcmToken', fcmToken);
            if(res && res.data){
                toastMessage('success', 'Your notification status updated');
            }else{
                toastMessage('error', 'Unable to update the FCM token');
            }
        });
    }, [fcmToken, userID]);

    onMessageListener().then(payload => {
        let body = JSON.parse(payload.notification.body);
        if(body.JobId){
            setJobNotifyModal(true);
            setJobTitle(payload.notification.title);
            setJobID(body.JobId);
            setJobData(JSON.parse(body.jsonBody));
        }else{
            toastMessage('success', payload.notification.body);
        }
    }).catch(err => console.log('failed: ', err));

    const handleAcceptJob = () => {
        setJobNotifyModal(false);
        let payload = {
            jobId: jobID,
            userId: userID
        };
        jobsActions.acceptJob(payload).then(res => {
            if(res && res.data){
               toastMessage('success', 'Job Accepted Successfully');
            }else{
                toastMessage('error', (res && res.message) || 'Try again later');
            }
        });
    }

    const handleDeclineJob = () => {
        setJobNotifyModal(false);
        let payload = {
            jobId: jobID,
            userId: userID
        };
        jobsActions.declineJob(payload).then(res => {
            if(res && res.data){
               toastMessage('success', 'Job Rejected Successfully');
            }else{
                toastMessage('error', (res && res.message) || 'Try again later');
            }
        });
    }

    return(
        <>
            {jobNotifyModal && <Modal t={t} jobTitle={jobTitle} jobData={jobData} title={t("sideNav.newJobRequest.title")} type={'notification'} showModal={jobNotifyModal} 
                handleOk={handleAcceptJob} handleCancel={handleDeclineJob} footerOption1={t("sideNav.newJobRequest.accept")} footerOption2={t("sideNav.newJobRequest.decline")} />}
        </>
    );
};

export default JobRequest;